webpackJsonp([82953272724940],{

/***/ 547:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{}}

/***/ })

});


// WEBPACK FOOTER //
// path---polityka-rachunkowosci-a0e39f21c11f6a62c5ab.js